import React from 'react';
import PaymentLinksTable from './table/PaymentLinksTable';
import { PaymentLinksUIProvider } from './context/PaymentLinksUIContext';
import { Box } from '@mui/material';
import PaymentLinksHeader from './PaymentLinksHeader';
import LinksDropMenu from './LinksDropMenu';

export default function PaymentLinks () {
    // Main Component
    return (
        <PaymentLinksUIProvider>
            <Box display='flex' flexDirection='column' className='pageContainerFluid'>
                <PaymentLinksHeader/>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <LinksDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <PaymentLinksTable/>
                    </div>
                </div>
            </Box>
        </PaymentLinksUIProvider>
    );
};
